import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import {
  LoginWithPasskeyButton,
  AuthenticationLayout,
  AuthenticationLayoutForm,
  BackToEmailStepButton,
  MFAResetButton, OtherMFAButton,
} from '../../Components';

export const AuthPasskeyLayout = ({ setAuthCollection }) => {
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'login-passkey-mfa-form'}
        onSubmit={onSubmit}
        errors={unsourcedErrors}
      >
        <FDStack direction={'column'} spacing={2}>
          <BackToEmailStepButton resource={resource} setAuthCollection={setAuthCollection} />
          <LoginWithPasskeyButton setAuthCollection={setAuthCollection} ButtonComponent={FDPrimaryActionButton} />
          <OtherMFAButton mfaType={'totp'} setAuthCollection={setAuthCollection} />
          <MFAResetButton />
        </FDStack>
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthPasskeyLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};

AuthPasskeyLayout.defaultProps = {};
